import { zonedTimeToUtc } from 'date-fns-tz';
import { formatDate } from '../../utility/worldReadyUtils';

// This function will return the date time in user's system timezone
export function getLocalTime(date) {
  const formattedDate = date.replace('T', ' ').replace('Z', ''); // e.g., Convert 2020-09-23T21:01:55Z to 2020-09-23 21:01:55
  try {
    return zonedTimeToUtc(formattedDate, 'America/Los_Angeles');
  } catch (e) {
    // for ie11
    const dateObj = new Date(date);
    return new Date(dateObj.getTime() + 7 * 60 * 60000); // offset for PDT is 7 hrs. there will be 1 hr diff in PST time
  }
}

export function formatDateLong(date, timeZone) {
  if (date) {
    const utcDateEqivalentInLocal = getLocalTime(date);
    return formatDate(utcDateEqivalentInLocal, {
      style: 'date-long',
      timeZone: timeZone || 'Etc/UTC',
    });
  }
  return null;
}

export function getRemainingDays(startDate, endDate) {
  if (startDate > endDate) {
    return 0;
  }
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.round(Math.abs((endDate - startDate) / oneDay));
}

export function getEndOfDayTime(date) {
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);

  return date;
}

export function sameDay(date) {
  const today = new Date();
  const dateToCompare = new Date(date); // the input date is in UTC

  return (
    today.getFullYear() === dateToCompare.getFullYear() &&
    today.getMonth() === dateToCompare.getMonth() &&
    today.getDay() === dateToCompare.getDay()
  );
}

// UTC and PST are the only supported timezones in this function
export function convertDateToUserTimezone(date, isUTC = false, timeZone) {
  if (!date) {
    return '';
  }

  let utcDate = date;
  if (!isUTC) {
    // Converting PST time to UTC
    utcDate = new Date(
      date.replace('T', ' ').replace('Z', ' ').replace(/-/g, '/').concat(' PST')
    ).toUTCString();
  }

  return formatDate(new Date(utcDate), {
    style: 'date-long',
    timeZone,
  });
}

// Format date object to short format string, e.g.: 6/4/22 or 4 June, 2022
export function parseDateOnly(date, isLongDateFormat = false) {
  date.setHours(0, 0, 0, 0);
  return formatDate(date, {
    style: isLongDateFormat ? 'date-long' : undefined,
    timeZone: 'Etc/UTC',
  });
}

export const getDefaultEndTime = () => {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 30);
  const formattedDate = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate()
  );
  formattedDate.setHours(0, 0, 0, 0);
  return formattedDate;
};

// Formats the date using the Intl module, default example: July 11, 2022
export function formatDateIntl({ date, locale, options }) {
  /* eslint-disable */
  const timezone =
    Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone ||
    'America/Los_Angeles';
  /* eslint-enable */

  const optionsObj = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: timezone,
    ...options,
  };
  return new Intl.DateTimeFormat(locale, optionsObj).format(new Date(date));
}

export function getCurrentYear(timeZone) {
  const currentDate = new Date();
  return formatDate(currentDate, {
    style: 'y',
    timeZone: timeZone || 'Etc/UTC',
  });
}

export function getCurrentYearStartDate() {
  const currentYear = new Date().getFullYear();
  const startDate = new Date(currentYear, 0, 1);
  return startDate.toISOString().split('T')[0];
}

export function getCurrentDate() {
  const currentDate = new Date();
  return currentDate.toISOString().split('T')[0];
}

export function getLastYearStartDate() {
  const lastYear = new Date().getFullYear() - 1;
  const lastYearStartDate = new Date(lastYear, 0, 1);
  return lastYearStartDate.toISOString().split('T')[0];
}

export function getLastYearEndDate() {
  const lastYear = new Date().getFullYear() - 1;
  const lastYearEndDate = new Date(lastYear, 11, 31);
  return lastYearEndDate.toISOString().split('T')[0];
}

export const getElapsedDays = (startDate) => {
  const endDate = new Date();
  return getRemainingDays(startDate, endDate);
};

export const getFormattedTimeOnlyFromUnix = (unixTime, locale) => {
  const date = new Date(unixTime * 1000);
  return date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  });
};
